import { api2 } from "../controllers/api";

export const getDriverFleetList = async (driverId, vehicleAssignId) => {
  try {
    let url = `/fleet/get/allVehicleOfDriverHub/?driver_id=${driverId}`;
    if (vehicleAssignId) {
      url += `&vehicle_assign_id=${encodeURIComponent(vehicleAssignId)}`;
    }
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const transferFleetChildHub = async (obj) => {
  try {
    const url = `/fleet/transferVehicle`;
    const result = await api2.post(url, obj);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getPerformanceTransaction = async (query) => {
  try {
    const url = `/fleet/paymentTransaction?${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getFleetLongLat = async (obj) => {
  try {
    const url = `/fleet/location`;
    const result = await api2.post(url, obj);
    return result;
  } catch (error) {
    throw error;
  }
};
export const AddCarTypeApi = async (vendorId, obj) => {
  try {
    const url = `/fleet/addCar/vendor/${vendorId}`;
    const result = await api2.put(url, obj);
    return result;
  } catch (error) {
    throw error;
  }
};

// /fleet/statusChange/:id
export const statusFleetAPI = async (fleetID, newObj) => {
  try {
    const url = `/fleet/statusChange/${fleetID}`;
    const result = await api2.post(url, newObj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const vehicleIdRefreshAPI = async (reg_number) => {
  try {
    const url = `/fleet/refreshVehicleUberId`;
    const result = await api2.post(url, { reg_number: reg_number });
    return result;
  } catch (error) {
    throw error;
  }
};

export const fleetParkingRenewImageUploadAPI = async (formData, fleetID) => {
  try {
    const url = `/fleet/renew/uploadImagesDocs/${fleetID}`;
    const result = await api2.putData(url, formData);
    //   const newResult = await result.json();
    return result;
  } catch (error) {
    throw error;
  }
};

export const fleetParkingRenewDocumentUploadAPI = async (data, fleetID) => {
  try {
    const url = `/fleet/renew/uploadDoc/${fleetID}`;
    const result = await api2.post(url, data);
    //   const newResult = await result.json();
    return result;
  } catch (error) {
    throw error;
  }
};
export const fleetRenewalDocHistoryAPI = async (fleetID, docType) => {
  try {
    const url = `/fleet/renew/historyDocs/${fleetID}?document_type=${docType}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const vehiclStatusChangeFromStatusAPI = async (fleetID, newObj) => {
  try {
    const url = `/fleet/vehicle-status/${fleetID}`;
    const result = await api2.put(url, newObj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const uploadBillMainteReviewAPI = async (id, newObj) => {
  try {
    const url = `/fleet/fleetUpload/${id}`;
    const result = await api2.postData(url, newObj);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCarSwapAPI = async (query) => {
  try {
    const url = `/fleet/carSwap?${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getCarSwapCSVAPI = async (query) => {
  try {
    const url = `/fleet/carSwap?${query ? query : ""}`;
    const result = await api2.getData(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const carSwapRequestAPI = async (vehicle_assign_request_id, data) => {
  try {
    const url = `/fleet/carSwap/${vehicle_assign_request_id}`;
    const result = await api2.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const assignCarToDriverAPI = async (driver_id, payload) => {
  try {
    const url = `/fleet/assignCarAutomatically/${driver_id}`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

export const uploadFleetDocumentsAPI = async (data, query) => {
  try {
    const url = `/fleet/fleetUpload/${query}`;
    const result = await api2.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const uploadFleetDocumentFromOcrAPI = async (data, query) => {
  try {
    const url = `/fleet/fleetUpload/${query}`;
    const result = await api2.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getUploadedFleetDocumentsAPI = async (query) => {
  try {
    const url = `/fleet/fleetUploadByTableId/${query}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getHandoverFleetDocumentAPI = async (query) => {
  try {
    const url = `/fleet/fleetHandoverCheckByTableId/${query}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const updateImagesEntryInBulk = async (data, query) => {
  try {
    const url = `/fleet/fleetBulkUpload/${query ? query : ""}`;
    const result = await api2.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};
export const fleetAllImagesUploadHistoryAPI = (query) => {
  try {
    const url = `/fleet/allImageUploads?${query ? query : ""}`;
    const result = api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getFleetListAPI = async (query) => {
  try {
    const url = `/fleet/list?${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getFleetListCsvAPI = async (query) => {
  try {
    const url = `/fleet/list/?${query ? query : ""}`;
    const result = await api2.getData(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getSchemeDetailsAPI = async (driverID) => {
  try {
    const url = `/fleet/getAllowedVehicleCountForVendor/${driverID}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const assignableTodayFleetAPI = async (type, query) => {
  try {
    const url = `/fleet/getAutoCarsForToday/${type}?${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const VehicleTypeDetailsAPI = async (type, query) => {
  try {
    const url = `/fleet/getCarTypeAsPerHub`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const downloadCSVCarSwapReportsAPI = async (query) => {
  try {
    const url = `/fleet/carSwap/csv?${query ? query : ""}`;
    const result = await api2.getData(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getHandoverReceiveImagesReportAPI = async (query) => {
  try {
    const url = `/fleet/getPendingImageJobs?${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getHandoverReceiveImagesReportCsvAPI = async (query) => {
  try {
    const url = `/fleet/getPendingImageJobs?type=csv&${query ? query : ""}`;
    const result = await api2.getData(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const updateFleetImageStatusAPI = async (data) => {
  try {
    const formData = new FormData();
    formData.append("status", data?.status);
    formData.append("req_id", data?.id);
    const url = `/fleet/fleetUpload/${data?.request_id}`;
    const result = await api2.postData(url, formData);
    return result;
  } catch (error) {
    throw error;
  }
};
// /fleet/fleetHandoverCheckByTableId/:id/:request_type

export const fleetOcrAPI = async (file) => {
  try {
    const url = `/fleet/processFileUsingOcr`;
    const result = await api2.postData(url, file);
    return result;
  } catch (error) {
    throw error;
  }
};
